/**
 * dev-ops-aware-users-api-green
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2024-11-01T00:23:40Z
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * A description of a company
 */
export interface Company { 
    /**
     * The address of the company
     */
    address?: string;
    /**
     * The database ID of the company
     */
    id: number;
    /**
     * the name of the company
     */
    name: string;
}
